/*
 * Product gallery free "chain" scrolling (mobile only).
 * The gallery scrolls continuously and rests wherever you stop — no snapping,
 * so you can sit between two images and see part of each.
 * - Touch: native free momentum scrolling (no JS needed; snap is disabled in CSS).
 * - Mouse: adds click-drag-to-scroll (which Dawn lacks) so the same free scroll
 *   works when testing on a desktop. No snap on release.
 * - Preserves tap/click-to-enlarge (only a real drag suppresses the click).
 */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');

  function initGallery(list) {
    if (list.__swipeInit) return;
    list.__swipeInit = true;

    var down = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    // Mouse click-drag to scroll freely (Dawn has no drag-to-scroll).
    // Touch is left entirely to the browser's native momentum scrolling.
    list.addEventListener('pointerdown', function (e) {
      if (!mq.matches || e.pointerType !== 'mouse') return;
      if (e.button !== 0) return;
      down = true;
      moved = false;
      startX = e.clientX;
      startScroll = list.scrollLeft;
      list.style.scrollBehavior = 'auto';
      if (list.setPointerCapture) {
        try { list.setPointerCapture(e.pointerId); } catch (err) {}
      }
    });

    list.addEventListener('pointermove', function (e) {
      if (!down || e.pointerType !== 'mouse') return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      list.scrollLeft = startScroll - dx; // free scroll, no snap
      e.preventDefault();
    }, { passive: false });

    function endDrag(e) {
      if (!down) return;
      down = false;
      list.style.scrollBehavior = '';
      if (moved) {
        // Swallow the click that would otherwise open the zoom modal after a drag.
        var swallow = function (ev) {
          ev.stopPropagation();
          ev.preventDefault();
        };
        list.addEventListener('click', swallow, true);
        setTimeout(function () {
          list.removeEventListener('click', swallow, true);
        }, 80);
      }
    }

    list.addEventListener('pointerup', endDrag);
    list.addEventListener('pointercancel', endDrag);
  }

  function boot() {
    var lists = document.querySelectorAll('.product__media-list');
    for (var i = 0; i < lists.length; i++) initGallery(lists[i]);
  }

  if (document.readyState !== 'loading') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
  }
  document.addEventListener('shopify:section:load', boot);
})();
